import { render } from "./pickingInfo.vue?vue&type=template&id=41206550&scoped=true&ts=true"
import script from "./pickingInfo.vue?vue&type=script&lang=ts"
export * from "./pickingInfo.vue?vue&type=script&lang=ts"

import "./pickingInfo.vue?vue&type=style&index=0&id=41206550&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41206550"]])

export default __exports__